import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form } from 'antd';

import { pageChanged } from '../../../data/redux/page_details/actions';
import { forgotPassword } from '../../../data/redux/admin_details/actions';
import { APP_PAGES, ROUTE_PATH } from '../../../data/config/constants';
import { showMessage } from '../../../data/config/utils';
import { MODULE_MESSAGE, BRAND_INFO } from '../../../data/config/urls';

import LogoCard from '../../../components/logocard';
import InputFormItem from '../../../components/form/formitem/inputformitem';
import ModalFooter from '../../../components/modalfooter';

function hasErrors(fieldsError) {
    return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class ForgotPasswordForm extends Component {
    componentWillMount() {
        this.props.actions.pageChanged(APP_PAGES.FORGOT_PASSWORD, 'ORI Dashboard');
    }

    componentDidMount() {
        this.props.form.validateFields();
    }

    handleInputChange = (event) => {
        this.props.form.setFieldsValue({
            [event.target.name]: event.target.value
        });
        this.props.form.validateFields();
    };

    handleSubmit = (e) => {
        e.preventDefault();
        const { form, actions } = this.props;
        form.validateFields((err) => {
            if (!err) {
                const payload = form.getFieldsValue(['email']);
                payload.host = window.location.origin;
                actions.forgotPassword(payload, this.goToLoginPage);
            } else {
                showMessage('error', 'Please enter/validate username and password!');
            }
        });
    };

    goToLoginPage = () => {
        this.props.history.push(ROUTE_PATH.LOGIN);
    };

    render() {
        const { form, auth_loading } = this.props;
        const { getFieldDecorator, getFieldsError, getFieldError, isFieldTouched } = form;
        const emailError = isFieldTouched('email') && getFieldError('email');

        return (
            <div className="ori-animated ori-fade-in-left ori-pad-10">
                <LogoCard
                    container_class="ori-b-mrgn-20 ori-pad-15 ori-text-center"
                    image_src={BRAND_INFO.logo_url}
                    title={MODULE_MESSAGE.AUTH.FORGOT_PASSWORD.title}
                    title_class="ori-font-md"
                    description={MODULE_MESSAGE.AUTH.FORGOT_PASSWORD.description}
                />
                <Form layout="vertical" onSubmit={this.handleSubmit}>
                    <InputFormItem
                        getFieldDecorator={getFieldDecorator}
                        validate_status={emailError ? "warning" : ""}
                        help={emailError || ''}
                        error_key="email"
                        rules={
                            [
                                { required: true, message: 'Please input your emailid' },
                                { type: 'email', message: "please enter a valid email id" }
                            ]
                        }
                        placeholder="Email"
                        input_name="email"
                        disabled={auth_loading}
                        onChange={this.handleInputChange}
                    />
                    <div className="ori-full-width ori-text-center ori-b-pad-10">
                        <p className="ori-font-xs">{`By continuing on ${BRAND_INFO.shortend_name} chatbot, you agree to our`} <span className="ori-font-primary ori-link-primary">Terms & Conditions</span>  and <span className="ori-font-primary ori-link-primary">Privacy Policy</span>.</p>
                    </div>
                    <ModalFooter
                        capsule_button
                        btn_style={{ minWidth: '40%' }}
                        btn_class="ori-height-40 ori-uppercase"
                        button_ok_text={auth_loading ? "REQUESTING" : "CONTINUE"}
                        button_ok_type="submit"
                        loading={auth_loading}
                        button_ok_disabled={hasErrors(getFieldsError()) || auth_loading}
                        handleCancelClick={this.goToLoginPage} />
                </Form>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        auth_loading: state.admin_details.loaders.auth_loading,
    };
}

const mapDispatchToProps = dispatch => {
    return {
        actions: bindActionCreators(
            {
                pageChanged,
                forgotPassword,
            },
            dispatch
        ),
    };
}

ForgotPasswordForm.propTypes = {
    form: PropTypes.object,
    actions: PropTypes.object,
    auth_loading: PropTypes.bool,
    history: PropTypes.object,
};

const ForgotPassword = Form.create()(ForgotPasswordForm);

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(ForgotPassword);


// WEBPACK FOOTER //
// ./src/app/authcontainer/forgotpassword/index.js